import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import { ClipboardService } from 'src/app/shared/services/clipboard.service';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../shared/services/auth.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ClearscapeService } from '../../clearscape.service';
import { Firestore, doc, docData, collection, collectionData, query, where } from '@angular/fire/firestore';
import { first, Observable } from 'rxjs';
import { IEnvironment } from 'src/app/shared/services/environment.types';


@Component({
  standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})

export class HeaderComponent implements OnInit {
  @ViewChild('tooltip') tooltip!: MatTooltip;
  mobileNavBarVisible: boolean = false;
  mobileNavBarCommunityMenuVisible: boolean = false;
  mobileNavBarDocsMenuVisible: boolean = false;
  isAdminUserRole: boolean = false;
  faCopy = faCopy;

  constructor( private dialog: MatDialog,public router: Router, public authService: AuthService, private clipboardService: ClipboardService,private clearscapeService:ClearscapeService, private firestore:Firestore) { }
  ngOnInit() {
    const email = this.authService.userData?.email;
    if (email) {
      docData(doc(this.firestore, `users/${email}`))
        .subscribe((user: any) => {
          this.isAdminUserRole = this.isAdminUser(user);
        });
    }
  }

  private openDialog(envs: IEnvironment[]) {
    const dialogRef = this.dialog.open(SignOutDialogComponent, {
      data: envs,
      width: '600px',
      maxWidth: '94vw',
      autoFocus: false,
      panelClass: 'app-dialog-panel',
    });
    dialogRef.afterClosed().subscribe(canSignOut => {
      if(canSignOut){
        this.authService.signOut()
      }
    });
  }

  showSignOutDialog() {
    this.mobileNavBarVisible = false;
    (collectionData(query(collection(this.firestore, 'environments'), where('owner', '==', this.authService.userData.email))) as Observable<IEnvironment[]>)
    .pipe(first())
    .subscribe((environments)=>{
      console.log('environments',environments)
      const envs = environments.filter((env)=>env.state === 'RUNNING');
      console.log('envs',envs);
      if(envs.length > 0){
        this.openDialog(envs);
      }else{
        this.authService.signOut();
      }
    })
    
  }

  toggleMobileNavBar() {
    this.mobileNavBarVisible = !this.mobileNavBarVisible;
  }

  copyToken() {
    this.clipboardService.copyToClipboard(localStorage.getItem("token")!, this.tooltip);
  }

  goToAdminPanel() {
    this.mobileNavBarVisible = false;
    this.router.navigate(['/admin']);
  }

  getAPIDocsLink() {
    return (environment.name === 'production') ? 'https://api.trial.teradata.com/api-docs' : `https://api.${environment.name}.trial.teradata.com/api-docs`;
  }

  toCreateAccountForm() {
    this.mobileNavBarVisible = false;
    window.location.href = 'https://www.teradata.com/experience';
  }

  private isAdminUser(user: any): boolean {
    if (!user) {
      return false;
    }

    return Boolean(
      user.isAdmin
      || user.admin
      || (typeof user.role === 'string' && user.role.toLowerCase() === 'admin')
      || (Array.isArray(user.roles) && user.roles.map((role: string) => role.toLowerCase()).includes('admin'))
    );
  }
}

@Component({
  standalone: false,
  selector: 'sign-out-dialog',
  templateUrl: 'sign-out.dialog.html',
  styleUrls: ['./sign-out.dialog.css']
})
export class SignOutDialogComponent {
  dontShowAgain: boolean = false;
  loading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<SignOutDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IEnvironment[],
    private clearscapeService:ClearscapeService,
    private authService: AuthService
  ) { }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
  
  onSignOut(): void {
    this.dialogRef.close(true);
  }

  onStopAndSignOut(): void {
    this.loading = true;
    this.clearscapeService.stopAll(this.data).subscribe({
      next: (value) => {
        console.log('Environment stopped successfully', value)
      },
      error: (error) => {
        console.log('Error stopping environment', error)
        this.loading = false;
      },
      complete: () => {
        console.log('All environments stopped successfully')
        this.authService.signOut();
        this.loading=false;
        this.dialogRef.close(true);
      }
    })
    
  }
}